import { createFileRoute } from "@tanstack/react-router";

import { UploadsPage } from "../../../workspaces/production/pages/UploadsPage";

export const Route = createFileRoute("/_console/production/uploads")({
  component: () => <UploadsPage />,
});
